import resolveResponsiveValue from './ResponsiveValueResolver';
/**
 * resolve factor to plain value
 * @param theme required for designGrid.base
 * @param factor
 */
export default function resolveNumericFactor(theme, screenWidth, numericFactor) {
    var actualNumericFactor = resolveResponsiveValue(theme, screenWidth, numericFactor);
    if (actualNumericFactor === undefined || actualNumericFactor === false) {
        return undefined;
    }
    if (typeof actualNumericFactor === 'object') {
        return actualNumericFactor.custom;
    }
    // convert to number in case of true
    var factorValue = actualNumericFactor;
    return theme.designGrid.base * factorValue;
}
//# sourceMappingURL=NumericFactorResolver.js.map